import {
  INVALID_ACCOUNT_TYPE,
  INVALID_ACCOUNT_ROUTING_NUMBER,
  INVALID_CANADA_EFT_LAST_FOUR,
  INVALID_ACCOUNT_FIRSTNAME,
  INVALID_ACCOUNT_LASTNAME,
  INVALID_ACCOUNT_NUMBER,
  MISSING_ACCOUNT_TYPE,
  MISSING_ACCOUNT_FIRSTNAME,
  MISSING_ACCOUNT_LASTNAME,
  MISSING_ACCOUNT_NUMBER,
  MISSING_ACCOUNT_ROUTING_NUMBER,
  MISSING_CANADA_EFT_LAST_FOUR,
} from '../../../constants/error-codes';

export default {
  firstName: [
    INVALID_ACCOUNT_FIRSTNAME,
    MISSING_ACCOUNT_FIRSTNAME,
  ],
  lastName: [
    INVALID_ACCOUNT_LASTNAME,
    MISSING_ACCOUNT_LASTNAME,
  ],
  routingNumber: [
    INVALID_ACCOUNT_ROUTING_NUMBER,
    MISSING_ACCOUNT_ROUTING_NUMBER,
  ],
  accountNumber: [
    INVALID_CANADA_EFT_LAST_FOUR,
    MISSING_CANADA_EFT_LAST_FOUR,
    INVALID_ACCOUNT_NUMBER,
    MISSING_ACCOUNT_NUMBER,
  ],
  accountType: [
    INVALID_ACCOUNT_TYPE,
    MISSING_ACCOUNT_TYPE,
  ],
};
